import HcMore from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import exportingModule from 'highcharts/modules/exporting'
import exportData from 'highcharts/modules/export-data'
import accessibility from 'highcharts/modules/accessibility'
import addVariwide from 'highcharts/modules/variwide'

HcMore(Highcharts)

exportingModule(Highcharts)
exportData(Highcharts)
accessibility(Highcharts)
addVariwide(Highcharts)

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    decimalPoint: '.',
  },
})

export { Highcharts }
